import React, {useContext, useState, useEffect, useMemo, useRef} from "react";
import {Link, useHistory} from "react-router-dom";
import styled from "@emotion/styled";
import firebase from "firebase/app";

import {UserContext} from "../../contexts/user";
import "./Header.scss";
import {LinkButton} from "../Button";
import ProfileIcon from "./ProfileIcon";
import {InstantSearch, Index, SearchBox, connectHits, Configure} from "react-instantsearch-dom";
import algoliasearch from "algoliasearch/lite";
import aa from "search-insights";
import defaultCategories from "../../constants/defaultSections";
import SubNav from "./SubNav";
import MobileMenu from "./MobileMenu";
import SearchIcon from "@/components/icons/search";
import {useDraft} from "@/contexts/draft";
import GenericHits from "./GenericHits";

const CustomHits = connectHits(GenericHits);

const Layout = styled.header`
 position: sticky;
 top: 0px;
 z-index: 5;

 .onboardingNav{
   padding: 1rem;
   display: flex;
   justify-content: space-between;
   background: white;
   button {
     background: lightGreen;
     margin-right: 1rem;
   }
 }
  .topNav {
    background: ${({theme}) => theme.mainColor};
    display: flex;
    min-height: 60px;
    padding: 0 20px;
    align-items: center;
    justify-content: space-between;

    nav {
      display: flex;
      justify-content: flex-end;
      @media screen and (max-width: 720px) {
        max-width: 200px;
      }
     
    }
  
  }

  .subNav {
    text-transform: uppercase;
    font-weight: 500;
    height: 44px;
    background: #003D00;
    display: flex;
    justify-content: center;


    @media screen and (max-width: 720px) {
      display: none;
    }
    a {
    color: lightGreen;
    :hover{
      color:white;
    }

    }
  }

  .logo {
    img {
      height: 30px;

      &.loading-logo {
        max-height: 32px;
        margin: 3px 0;
      }
    }
  }

  
  .nav_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    @media screen and (max-width: 700px){
      .cart-count{
       display: none;
      }
     }
    .draftButton {
      padding: 0.5rem 0.4rem;
      font-size: 1rem;
      font-weight: bold;
      margin-right: 1rem;
      border: 2px solid  ${({theme}) => theme.mainTextColor};
      background:  ${({theme}) => theme.mainColor};
      color: ${({theme}) => theme.mainTextColor};
      :hover {
        background:  ${({theme}) => theme.mainTextColor};
        color: ${({theme}) => theme.mainColor};
      }
    }

    a {
      padding: 0;
    }
    .authButton {
      font-size: 0.8rem;
      padding: 0.5rem 0.4rem;
      font-weight: bold;
      background: #0f0: 
      width: 120px;
      margin-left: 0.5rem;
    }
  }

  .desktop {
    display: none;
  }

  @media screen and (min-width: 868px) {
    .desktop {
      display: block;
    }
    .mobile {
      display: none;
    }
  }
  .searchBox_wrapper {
    max-width: 350px;
    @media screen and (max-width: 720px) {
      max-width: 200px;
      min-width: 30px
    }
  }

  .search-container {
    max-width: 250px;
    @media screen and (max-width: 720px) {
      max-width: 131px;
      min-width: 30px
    }
    color: black;
    position: relative;
    margin-right: 1rem;
    display: flex;
    flex-direction: column;
    .input-holder {
      display: flex;
      max-width: 250px;
    }
    .ais-SearchBox-reset {
      display: none;
    }

    /* Hides the native 'X' added by some browsers (like Chrome/Safari) */
    .ais-SearchBox-input::-webkit-search-cancel-button {
      -webkit-appearance: none;
      display: none;
    }

    .ais-SearchBox-resetIcon {
      display: none;
    }
    .ais-SearchBox-submitIcon {
      display: none;
      visibility: hidden;
    }
    .ais-SearchBox-input {
      width: 250px;
      background: ${({theme}) => theme.almostBlack};
      border: none;
      padding: 10px 20px 10px 10px;
      border-radius: .5rem;
      font-size: 1.2rem;
      font-weight: bold;
      transition: all 120ms ease-in-out;
      outline-color: ${({theme}) => theme.darkGreen};
      color: ${({theme}) => theme.green};
    }
    .ais-SearchBox-form {
      button {
        display: none;
      }
    }
    &.active input {
      max-width: 250px;
      color: white;

      width: 100%;
      outline-color: ${({theme}) => theme.green};
      @media screen and (min-width: 870px) {
        max-width: 250px;
      }
    }
    i.search {
      color: ${({theme}) => (theme.mainTextColor ? theme.mainTextColor : "white")};
      position: absolute;
      top: 50%;
      right: 10px;
      height: 16px;
      width: 19px;
      transform: translate(0, -50%);
      cursor: pointer;

      path {
        fill: ${({theme}) => (theme.mainTextColor ? theme.mainTextColor : "#0F0")};
      }
    }
  }

  .profile img {
    height: 40px;
    width: 40px;
    object-fit: cover;
    display: block;
    margin-right: 1rem;
    box-shadow: 0 0.15em ${({theme}) => (theme.mainTextColor ? theme.mainTextColor : theme.darkGreen)},
      0 -0.15em ${({theme}) => (theme.mainTextColor ? theme.mainTextColor : theme.darkGreen)},
      0.15em 0 ${({theme}) => (theme.mainTextColor ? theme.mainTextColor : theme.darkGreen)},
      -0.15em 0 ${({theme}) => (theme.mainTextColor ? theme.mainTextColor : theme.darkGreen)};

    &:hover,
    &:focus {
      box-shadow: 0 0.15em ${({theme}) => theme.veryDarkGreen}, 0 -0.15em ${({theme}) => theme.veryDarkGreen},
        0.15em 0 ${({theme}) => theme.veryDarkGreen}, -0.15em 0 ${({theme}) => theme.veryDarkGreen};
    }
  }

  nav {
    display: flex;
    align-items: center;
    font-family: "IBM Plex Mono", monospace;
    font-weight: 600;
    @media screen and (max-width: 720px) {
      gap: 12px;
    }
    .desktopView {
      display: flex;
      align-items: center;
      > a {
        margin: 5px;
      }
    }
    .mobileView {
      display: none;
      padding: 0px;
    }
    @media screen and (max-width: 720px) {
      .desktopView {
        display: none;
      }
      .mobileView {
        display: block;
        font-size: 25px;
      }
    }
    .mobileLinks {
      display: flex;
      flex-direction: column;
      position: absolute;
      margin-right: 2px;
      top: 50px;
      padding: 10px;
      right: 0;
      background-color: #fff;
      border: 2px solid #336712;
      border-radius: 10px;
      transition: 0.5s all;
    }
    a {
      color: ${({theme, darkMode}) => (darkMode ? theme.veryDarkGreen : theme.veryDarkGreen)};
    }

    .button {
      color: ${({theme, darkMode}) => (darkMode ? theme.veryDarkGreen : theme.veryDarkGreen)};
      border-color: ${({theme, darkMode}) => (darkMode ? theme.veryDarkGreen : theme.veryDarkGreen)};
      background-color: ${({theme, darkMode}) => (darkMode ? theme.green : theme.green)};
    }

    a,
    button {
      text-decoration: none;
    }

    a.profile {
      margin-left: 10px;
    }

    > a,
    > button {
      margin-left: 20px;

      &:hover {
        color: #003b00;
      }
    }
  }
`;

const Icon = styled.img`
  width: 40px;
  height: auto;
  margin-right: 1em;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

const Badge = styled.span`
  color: #3c3c3b;
  font-weight: bold;
  padding: 5px;
  display: inline-block;
  text-decoration: none;
  display: flex;
  align-items: center;
  width: auto;
  line-height: 1em;
  cursor: pointer;
  box-shadow: 0 0.2em #f6f7f9, 0 -0.2em #f6f7f9, 0.2em 0 #f6f7f9, -0.2em 0 #f6f7f9;
`;

const SearchSuggestionContainer = styled.div`
  // border: 2px solid grey;
  padding: 5px 5px 20px 5px;
  position: absolute;
  z-index: 9999;
  width: 35vw;
  top: 35px;

  background: #212428;
  color: ${({theme}) => theme.mainTextColor};

  @media only screen and (max-width: 768px) {
    width: 94vw;
  }

  div {
    font-size: 13px;
  }

  .search-results {
    overflow-y: scroll;
    max-height: 700px;
    margin-bottom: 10px;
    max-width: auto;
  }

  .story-result {
    cursor: pointer;
    margin: 10px;
    width: 100%;

    .story-title {
    }

    div {
      margin-right: 10px !important;
    }

    height: 60px;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-box;
    display: box;
    align-items: center;
    padding: 0 5px;

    .story-title {
      margin-left: 10px;
      font-size: 18px;
      max-width: 580px;
    }
    &:hover {
      background-color: ${({theme}) => theme.mainTextColor};
      color: ${({theme}) => theme.mainColor};
      transition: 0.4s;
      border-radius: 4px;
    }
  }

  .search-section-header {
    font-weight: bold;
    font-size: 1.5rem;
    margin: 10px;
    font-style: italic;
  }

  .horizontal {
    display: flex;
    justify-content: space-evenly;

    div {
      border-radius: 5px;
      background-clip: padding-box;
      border: 7px double transparent;

      :hover {
        cursor: pointer;
        color: black;
        text-decoration: underline;
      }
    }
  }

  .stacked {
    margin: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .footer {
    width: 100%;
    align-items: center;
    float: right;
    position: absolute;
    background: #f6f7f9;
    display: flex;
    justify-content: flex-end;
    bottom: 0;
    right: 0;

    a {
      display: flex;
      align-items: center;
      margin: 2px 10px;
    }

    .search-by {
      margin: 7px;
    }

    .algolia-link {
      float: right;
    }
  }
`;

const StoryTag = styled(Badge)`
  padding: 10px;
  margin: 0 10px 10px 0;
  background-color: ${({theme, value}) => (value ? `${theme.veryDarkGreen}` : theme.veryLightGrey)};

  &:hover {
    background: ${({theme}) => theme.green};
    color: ${({theme}) => theme.veryDarkGrey};
    box-shadow: 0 0.2em ${({theme}) => theme.darkGreen}, 0 -0.2em ${({theme}) => theme.darkGreen},
      0.2em 0 ${({theme}) => theme.darkGreen}, -0.2em 0 ${({theme}) => theme.darkGreen};
    transition: all 120ms ease-in-out;
  }

  @media screen and (min-width: 768px) {
    font-size: 1rem;
  }
`;

const SectionButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
  margin-left: 1em;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const SectionButton = styled.button`
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 4px;
  font-weight: bold;
  background-color: ${props => (props.isActive ? "#0f0" : "#1a1a1a")};
  color: ${props => (props.isActive ? "#1a1a1a" : "#a0a0a0")};
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  &:focus {
    outline: none;
  }
`;

export default function Header() {
  const {user, userDispatch, authenticated, setIsOnboarding, isOnboarding, loadingAuthState, logout} =
    useContext(UserContext);
  const history = useHistory();
  const [showMobile, setShowMobile] = useState(false);
  const [shouldDisplaySuggestion, setShouldDisplaySuggestion] = useState(false);
  const [reload, setReload] = useState(false);
  const [isBrand, setIsBrand] = useState(location.pathname.includes("brand"));
  const [typedSearch, setTypedSearch] = useState("");
  const [categories, setCategories] = useState(null);
  const {draft, draftDispatch, setDraft} = useDraft();
  const [activeSection, setActiveSection] = useState("all");
  const searchRef = useRef(null);

  const searchClient = algoliasearch("MO7DWH9Y8C", "e0088941fa8f9754226b97fa87a7c340", {
    headers: {
      "X-Algolia-UserToken": user.uid,
    },
  });

  let unmounted = false;

  useEffect(() => {
    if (!unmounted) {
      fetchData();
    }

    aa("init", {
      appId: "MO7DWH9Y8C",
      apiKey: "9aea47c20f7e7ff1881934f74de32eae",
    });

    return () => {
      unmounted = true;
    };
  }, []);

  // useEffect(() => {
  //   window.addEventListener("click", () =>
  //     setTimeout(() => {
  //       setShouldDisplaySuggestion(false);
  //     }, 200),
  //   );

  //   setIsOnboarding(false);
  // }, []);

  useEffect(() => {
    const handleClickOutside = event => {
      if (searchRef?.current && !searchRef?.current.contains(event.target)) {
        setShouldDisplaySuggestion(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setIsBrand(location.pathname.includes("brand"));
  }, [reload]);

  const fetchData = async () => {
    const staticDataDoc = await firebase.firestore().collection("static-data").doc("green-top-nav").get();
    if (staticDataDoc.exists) {
      const json = staticDataDoc.data().json;
      setCategories(json);
    } else {
      setCategories(defaultCategories);
    }
  };

  const newEditor = async (markdown = " ", title = "", tags = [], mainImage = "", draftTemplateId = null) => {
    let newDraft;
    if (typeof markdown !== "string") {
      newDraft = true;
      markdown = " ";
    }
    const draftRef = firebase.firestore().collection("drafts").doc();
    await draftRef.set({
      owner: firebase.auth().currentUser.uid,
      newDraft: true,
      mainImage,
      title,
      tags: tags ? tags : [],
      markdown,
      templateId: draftTemplateId,
    });

    const draft = await draftRef.get();
    setDraft(draft);
    draftDispatch({type: "reset"});

    history.push(`/mobile/${draft.id}`);
    history.go(0);
  };

  const searchClientWithOutEmptySearch = useMemo(
    () => ({
      search(requests) {
        if (!requests[0].params.query) return [];
        const updatedRequest = requests.map(item => {
          if (activeSection !== "all") {
            item.params.facetFilters = [[`type:${activeSection}`]];
            item.params.hitsPerPage = 10;
          } else {
            item.params.hitsPerPage = 25;
          }
          return {...item};
        });
        return searchClient.search(updatedRequest);
      },
    }),
    [searchClient, activeSection],
  );

  const onSearchSubmit = e => {
    if (!e) return;
    e.preventDefault();
    const searchvalue = e.target[0].value;
    window.open(`https://hackernoon.com/search?query=${searchvalue}`, "_self");
  };

  const clickSearchResult = (route, hit, eventName) => {
    if (user.uid && user.trackingOptIn) {
      aa("clickedObjectIDsAfterSearch", {
        userToken: user.uid,
        eventName: "clicked_" + eventName,
        index: "stories",
        queryID: hit.__queryID,
        objectIDs: [hit.objectID],
        positions: [hit.__position],
      });
    }
    window.open(`https://hackernoon.com/${route}`, "_self");
  };

  if (loadingAuthState) {
    return (
      <Layout>
        <div className="logo">
          <img
            src="https://cdn.hackernoon.com/watch-gif.gif"
            alt="HackerNoon spinning watch"
            className="loading-logo"
          />
        </div>
      </Layout>
    );
  }

  const tagClick = hit => {
    if (user.uid && user.trackingOptIn) {
      aa("clickedObjectIDsAfterSearch", {
        userToken: user.uid,
        eventName: "clicked_story",
        index: "stories",
        queryID: hit.__queryID,
        objectIDs: [hit.objectID],
        positions: [hit.__position],
      });
    }
    window.open(`https://hackernoon.com/tagged/${hit.slug}`, "_self");
  };

  const tempImageFix = url => {
    if (!url) return "https://cdn.hackernoon.com/fallback-feat.png";

    if (!url.startsWith("http")) {
      url = new URL(url, "https://hackernoon.com/").toString();
    }

    url = url.replace("https://hackernoon.com/", "https://cdn.hackernoon.com/");

    return url;
  };

  const sections = [
    {
      id: "all",
      label: "All",
    },
    {
      id: "stories",
      label: "Blogs",
    },
    {
      id: "profiles",
      label: "People",
    },
    {
      id: "companies",
      label: "Companies",
    },
    {
      id: "tags",
      label: "Topics",
    },
    {
      id: "coins",
      label: "Coins",
    },
  ];

  return (
    <Layout colors={user.colors}>
      <div
        className={`topNav ${user.colors && user.colors.preset === "BlossomBytes" ? "blossomBytes" : ""}`}
        style={
          user.colors && {
            background:
              user.colors.preset === "Pride"
                ? "-webkit-linear-gradient(left, #FBFAF6 0, #FBFAF6 9.09%, #F7AEC4 9.09%, #F7AEC4 18.18%, #74D7EE 18.18%, #74D7EE 27.27%, #603814 27.27%, #603814 36.36%, #010101 36.36%, #010101 45.45%, #DA0A0A 45.45%, #DA0A0A 54.54%, #F09D03 54.54%, #F09D03 63.63%, #E5FE04 63.63%, #E5FE04 72.72%, #08BF02 72.72%, #08BF02 81.81%, #08199B 81.81%, #08199B 90.90%, #77018B 90.90%, #77018B)"
                : user.colors.mainColor,
            backgroundImage: user.colors.preset === "BlossomBytes" ? "url('/spring-theme.webp')" : "",
          }
        }
      >
        <div className="searchBox_wrapper">
          {user && user?.uid && (
            <InstantSearch
              searchClient={searchClientWithOutEmptySearch}
              indexName={`${process.env.REACT_APP_ENV === "development" ? "dev_" : ""}public`}
            >
              {/* <Configure hitsPerPage={5} /> */}
              <div className="search-container active">
                <div className="input-holder">
                  <SearchBox
                    searchAsYouType={true}
                    onSubmit={onSearchSubmit}
                    onChange={e => {
                      e.target.value === "" ? setShouldDisplaySuggestion(false) : setShouldDisplaySuggestion(true);
                      setTypedSearch(e.target.value);
                    }}
                    name="searchvalue"
                    translations={{placeholder: "Discover Anything"}}
                    focusShortcuts={[...(history?.location?.pathname?.includes("page-builder") ? [] : ["s"])]}
                    tabIndex={1}
                  />
                  <i className="search">
                    <SearchIcon alt="Search icon" width={19} height={16} />
                  </i>
                </div>
                {shouldDisplaySuggestion && (
                  <SearchSuggestionContainer ref={searchRef}>
                    <SectionButtonContainer>
                      {sections.map(section => (
                        <SectionButton
                          key={section.id}
                          isActive={section.id === activeSection}
                          onClick={() => setActiveSection(section.id)}
                        >
                          {section.label}
                        </SectionButton>
                      ))}
                    </SectionButtonContainer>

                    <div className="search-results">
                      <CustomHits user={user} hit />
                    </div>

                    <div className="footer">
                      <a
                        className="algolia-link"
                        href="https://www.algolia.com/developers/?utm_source=hackernoon&utm_medium=referral&utm_campaign=onepager_devhub_hackernoon"
                      >
                        <img src="/search-by-algolia-light-background.svg" height={24} width={168} />
                      </a>
                    </div>
                  </SearchSuggestionContainer>
                )}
              </div>
            </InstantSearch>
          )}
        </div>
        <a
          className="logo"
          href="https://hackernoon.com"
          style={{
            backgroundColor: user.colors?.preset === "SOTY" ? "#0f0" : user.colors?.preset === "SOTY" ? "#0f0" : "",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <img src="https://cdn.hackernoon.com/hn-logo.png" alt="Hackernoon logo" className="desktop" />
          <img src="https://cdn.hackernoon.com/hn-icon.png" alt="Hackernoon logo" className="mobile" />
        </a>

        <nav>
          <div className="nav_right">
            {user?.isAuthor && authenticated && !isOnboarding && (
              <a href="https://hackernoon.com/new" className="desktop draftButton">
                Start Writing
              </a>
            )}
            {!loadingAuthState && authenticated && isOnboarding && (
              <a
                href="https://hackernoon.com/onboarding"
                onClick={() => setReload(!reload)}
                className="nav_right draftButton"
              >
                Complete Profile
              </a>
            )}
            {!authenticated && !location.pathname.includes("login") && (
              <LinkButton
                onClick={() => setReload(!reload)}
                to={isBrand ? "/brandlogin" : "/login"}
                className="authButton"
              >
                LOGIN
              </LinkButton>
            )}
            {!authenticated && !location.pathname.includes("signup") && (
              <LinkButton
                onClick={() => setReload(!reload)}
                to={isBrand ? "/brandsignup" : "/signup"}
                className="authButton"
              >
                CREATE ACCOUNT
              </LinkButton>
            )}
          </div>
          <div className="nav_right">
            {authenticated && !isOnboarding && <ProfileIcon user={user} />}
            {authenticated && !isOnboarding && (
              <a href="/notifications">
                <Icon src="https://cdn.hackernoon.com/unread-bell.png"></Icon>
              </a>
            )}
            {authenticated && (
              <a href={user?.onCart > 0 ? "/services/cart" : "/services"} style={{fontSize: "30px"}}>
                <span>
                  <svg width="28" height="25" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M27.75 1.75V5.5H26.5V9.25H25.25V13H24V14.25H9V16.75H24V19.25H7.75V18H6.5V13H5.25V6.75H4V3H0.25V0.5H4V1.75H27.75Z"
                      fill="#005d15"
                    />
                  </svg>
                </span>
                {user?.onCart > 0 && (
                  <span className="cart-count" style={{fontSize: "15px"}}>{`(${user?.onCart})`}</span>
                )}
              </a>
            )}
            {authenticated && categories && (
              <div className="mobileView">
                <MobileMenu categories={categories} />
              </div>
            )}
            {showMobile && authenticated && !isOnboarding && (
              <div className="mobileLinks">
                {user.isAdmin && (
                  <Link to="/admin" onClick={() => setShowMobile(!showMobile)}>
                    ADMIN
                  </Link>
                )}
                {user.isEditor && (
                  <Link to="/editor" onClick={() => setShowMobile(!showMobile)}>
                    EDITORS
                  </Link>
                )}
                {categories.map((category, idx) => (
                  <>
                    {category.text === "BRAND" ? (
                      <>
                        {user.isBrand && (
                          <Link key={category.text} to={category.href} onClick={() => setShowMobile(!showMobile)}>
                            {category.text}
                          </Link>
                        )}
                      </>
                    ) : (
                      <Link key={category.text} to={category.href} onClick={() => setShowMobile(!showMobile)}>
                        {category.text}
                      </Link>
                    )}
                  </>
                ))}
              </div>
            )}
          </div>
        </nav>
      </div>
      {user && authenticated && <SubNav colors={user.colors} />}
    </Layout>
  );
}
